import ActionTypes from '../actions/types';
import { canonicalizeSpotIdentifier } from './../utils';
import { setState, resetState } from './helper';
import { defaultState } from './defaultState';

const initialState = defaultState.parkingSpots;

const updateParkingSpotInfos = (state, action) => {
  const processedList = {};
  const { data } = action;
  for(let spotIdentifier in data){
    const spotId = canonicalizeSpotIdentifier(spotIdentifier);
    const newItem = {
      ...state.list[spotId],
      ...data[spotIdentifier],
    };
    processedList[spotId] = newItem;
  }
  const newList = {
    ...state.list,
    ...processedList,
  };
  return setState(state, { list: newList }, 'list');
};

export default (state = initialState, action) => {
  switch(action.type) {
    case ActionTypes.SELECT_POINT_OF_INTEREST:
      return setState(state, action, 'selectedPointsOfInterest');

    case ActionTypes.RESET_SELECTED_POINT_OF_INTEREST:
      return resetState(state, 'selectedPointsOfInterest');

    case ActionTypes.SELECT_PARKING_SPOT:
      return setState(state, action, 'selectedSpot');

    case ActionTypes.RESET_SELECTED_SPOT:
      return resetState(state, 'selectedSpot');

    case ActionTypes.SET_PARKING_SPOT_DETAILS:
      return setState(state, action, 'list');

    case ActionTypes.UPDATE_PARKING_SPOT_INFOS:
      return updateParkingSpotInfos(state, action);

    case ActionTypes.TOGGLE_PARKING_AREA_MARKERS:
      return setState(state, action, 'showParkingAreaMarker');

    case ActionTypes.TOGGLE_PARKING_SPOT_MARKERS:
      return setState(state, action, 'showParkingSpotMarker');

    case ActionTypes.TOGGLE_PARKING_SPOT_MARKERS_LABEL:
      return setState(state, action, 'showParkingSpotMarkerLabel');

    case ActionTypes.SET_GROUPED_PARKING_SPOTS:
      return setState(state, action, 'groupedParkingSpots');

    case ActionTypes.SET_DEFAULT_STATE_TIMESTAMP:
      return setState(state, action, 'parkingDataFetchedAt');

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/parkingSpotsReducer.js